export const CONTRACT_TYPE = { advance: 'advance', spot: 'spot' } as const

export type ContractType = (typeof CONTRACT_TYPE)[keyof typeof CONTRACT_TYPE]

export const CONTRACT_TYPE_LABEL: { [key in ContractType]: string } = { advance: '事前契約', spot: '現物契約' }
